import React from 'react'

import { ItemList } from './ItemList'

import './Browse.sass'

const Browse: React.FC = () =>
  <div className="browse">
    <div className="action-buttons-top"></div>
    <ItemList />
  </div>

export default Browse
